import failedMedia from '@/directives/failed_media'
import clickOutsideDirective from '@/directives/click-outside'
import loadingPld from '@/directives/loading'
import draggabilly from '@/directives/draggabilly'

export const FailedMedia = failedMedia
export const ClickOutside = clickOutsideDirective
export const LoadingPld = loadingPld
export const Draggabilly = draggabilly
